import type { ReactElement } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@-/dev.improve.haniverse.components.ui.dropdown-menu";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { useToolbarGridMetrics } from "@-/dev.improve.haniverse.components.ui.toolbar.button.view";

/**
 * The lesson pill's card-actions menu on Android and web, drawn by the shared JS dropdown. iOS uses
 * the system menu instead (`learn-card-lesson-menu.ios.tsx`).
 */
export function LearnFlashcardLessonMenu({
  isDisabled,
  onMarkKnown,
  onSkip,
  trigger,
}: {
  isDisabled: boolean;
  /** `null` hides "Mark Known" (a pronunciation-level lesson marks nothing on the meaning card). */
  onMarkKnown: (() => void) | null;
  onSkip: () => void;
  trigger: ReactElement;
}) {
  const { isLandscape } = useToolbarGridMetrics();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent
        align={isLandscape ? "end" : "start"}
        className="min-w-48"
        side="top"
        sideOffset={8}
      >
        {onMarkKnown === null ? null : (
          <DropdownMenuItem disabled={isDisabled} onPress={onMarkKnown} testID="lesson-mark-known">
            <Text>Mark Known</Text>
          </DropdownMenuItem>
        )}
        <DropdownMenuItem disabled={isDisabled} onPress={onSkip} testID="lesson-skip-card">
          <Text>Skip</Text>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
